/*#__PURE__*/ export default JSON.parse('{"key":"","type":"root","items":[{"key":"codeSnippets","def":[],"type":"list","listItemsType":"string"}]}');